import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";

export default function FavoriteAthletesList({ athletesLiked, onViewAthlete }) {
  return (
    <>
      <h3 className="text-xl font-medium mt-6 mb-4 ">Favorite Athletes</h3>
      <div className="h-[calc(100dvh-300px)] overflow-auto pr-4 -mr-4">
        <ul>
          {athletesLiked.length > 0 ? (
            athletesLiked.map((athlete) => (
              <li
                key={athlete.userAthleteId}
                className="flex justify-between items-center border px-3 py-2 rounded-lg shadow-sm mb-2"
              >
                <div className="flex items-center">
                  <img
                    alt={`${athlete.name} ${athlete.lastname}`}
                    src={athlete.profilePicture || "/default-profile-img.png"}
                    className="h-[40px] w-[40px] mr-2 rounded-md"
                  />
                  <div className="flex flex-col mr-4">
                    <span className="text-base lg:text-lg">
                      {athlete.name} {athlete.lastname}
                    </span>
                    <span className="text-sm text-gray-700">
                      {athlete.position}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-end space-x-8">
                  <span className="flex items-center justify-center h-[32px] xl:h-[40px] w-[32px] xl:w-[40px] rounded-full bg-yellow-500">
                    <FontAwesomeIcon
                      icon={faThumbsUp}
                      style={{ color: "#fff" }}
                    />
                  </span>

                  <span className="text-lg font-semibold bg-700 text-white px-2 py-1 rounded mr-2 hidden">
                    {athlete.trackittScore}
                  </span>
                  <button
                    onClick={() => onViewAthlete(athlete)}
                    className="text-sm px-2 py-1.5 text-white bg-red-500 rounded hover:bg-red-700"
                  >
                    VIEW
                  </button>
                </div>
              </li>
            ))
          ) : (
            <li className="flex justify-center items-center h-32">
              <span className="text-lg text-gray-500">
                No favorite athletes marked.
              </span>
            </li>
          )}
        </ul>
      </div>
    </>
  );
}
